<script setup>
import {computed, onMounted, ref, watch} from "vue";
import PageTitle from "@/components/common/PageTitle.vue";
import NavCard from "@/components/common/NavCard.vue";
import { useI18n } from 'vue-i18n';
import {useRoute, useRouter} from "vue-router";
import {getAvailableActionsForRoute} from "@/services/api/permissionManagement.js";

const { t } = useI18n();
const router = useRouter();
const actionsContract = ref(null);
const actionsProduct = ref(null);
const actionsConnections = ref(null);
const isLoaded = ref(false);
const havePermissions = ref(false);

const breadcrumbs = computed(() => {
    const items = [
        { label: t("components.settings.permissionManagement.menuList.Contracts"), to: "/contracts" }
    ];
    return items;
});

const cards = computed(() => {
    const baseCards = [];
    if (actionsContract.value?.list?.length) {
        baseCards.unshift({
            title:"components.settings.permissionManagement.menuList.Contracts",
            subtitle:"components.contracts.index.contractDescription",
            icon: "description",
            routeName: "contracts/contract-list",
        });
    }

    if (actionsConnections.value?.list?.length) {
        baseCards.unshift({
            title:"components.contracts.connection.pageTitle",
            subtitle:"components.contracts.index.connectionDescription",
            icon: "lan",
            routeName: "contracts/connections",
        });
    }

    return baseCards;
});

watch(cards, (newCards) => {
    havePermissions.value = newCards.length > 0;
});

onMounted(async  () => {
    try {
        actionsContract.value = await getAvailableActionsForRoute("Resources/Contracts/Contracts");
        actionsConnections.value = await getAvailableActionsForRoute("Resources/Contracts/Connections");
        if(actionsContract.value?.list?.length && !actionsConnections.value?.list?.length) {
            await router.push("/contracts/contract-list");
        }
    } catch (err) {
        console.error("Error Permissions: ", err);
    } finally {
        isLoaded.value = true;
    }
})

</script>
<template>
    <div v-if="isLoaded && havePermissions && $route.name === '/contracts' ">
        <PageTitle :breadcrumbs="breadcrumbs" />
        <v-card class="bg-white trezo-card  base-page-height">
            <NavCard :cards="cards" />
        </v-card>
        <router-view />
    </div>

    <div v-else-if="isLoaded && !havePermissions">
        <v-alert class="text-danger">
            {{ t("common.messages.errors.403") }}
        </v-alert>
    </div>
</template>

